<script>
  import { createEventDispatcher, onDestroy, onMount } from "svelte";
  import { throttle } from "../../helpers";

  export let hasNext;
  export let loading = false;

  const dispatch = createEventDispatcher();

  const throttledScroll = throttle(() => {
    const bottomDetectOffset = 200;
    
    const pageHeight = Math.max(
      document.body.scrollHeight, 
      document.body.offsetHeight, 
      document.documentElement.clientHeight, 
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    );
    
    if ((window.innerHeight + window.scrollY) >= pageHeight - bottomDetectOffset) {
      if (!hasNext) {
        return;
      }

      if (loading) {
        return;
      }

      dispatch('load');
    }
  }, 500);

  const createScrollListener = () => window.addEventListener('scroll', throttledScroll);
  const destroyScrollListener = () => window.removeEventListener('scroll', throttledScroll);

  onMount(createScrollListener);
  onDestroy(destroyScrollListener);
</script>